import { render, staticRenderFns } from "./BCDRequestForm.vue?vue&type=template&id=3a4dd2f2&scoped=true"
import script from "./BCDRequestForm.vue?vue&type=script&lang=js"
export * from "./BCDRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4dd2f2",
  null
  
)

export default component.exports